import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ObrasService from '../../services/obras'
import Obra from './obra';
import Moment from 'moment';


const ListarObrParalizadas = () => {
    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [situacao, setSituacao] = useState("Paralizada");
    const [obras, setObras] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchObras() {
        var finalQuery = await preparaQuery();
        if (finalQuery === "") {
            // nada
        } else {
            var response = await ObrasService.buscar(finalQuery)
            if (response.data.length >= 1) {
                setObras(response.data)
                setVazio(false)
            } else {
                setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        return prepQuery;
    }


    useEffect(() => {
        fetchObras();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setObras={setObras}
                    setVazio={setVazio}
                    fetchObras={fetchObras}
                    obras={obras}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={2}>
                        {obras.map((obr, index) =>
                            <Obra
                                obr={obr}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarObrParalizadas;